import { render, staticRenderFns } from "./pricingPage.vue?vue&type=template&id=566e5143&"
import script from "./pricingPage.vue?vue&type=script&lang=js&"
export * from "./pricingPage.vue?vue&type=script&lang=js&"
import style0 from "./pricingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports